import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"verticalRule\" data-test-vertical-rule></div>")